import { render, staticRenderFns } from "./integral-mall-goods-order.vue?vue&type=template&id=0c2f68da"
import script from "./integral-mall-goods-order.vue?vue&type=script&lang=ts"
export * from "./integral-mall-goods-order.vue?vue&type=script&lang=ts"
import style0 from "./integral-mall-goods-order.vue?vue&type=style&index=0&id=0c2f68da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports